import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AnalystProgressResponse,
  AnalystTurnStatus,
  AskChatRequest,
  ChatResponse,
  ChatWithMessagesResponse,
  CreateChatRequest,
  CreditBalanceResponse,
  CreditConsumptionEntry,
  GenerateReportRequest,
  PatchChatRequest,
  ReportJobStatus,
  SubmitFeedbackRequest,
} from 'src/app/models/chat.model';
import { ChatMessageExportFormat } from 'src/app/enums/chatMessageExportFormat.enum';

export abstract class ChatService {
  abstract createChat(request: CreateChatRequest): Observable<ChatResponse>;

  abstract getTurnProgress(chatId: string): Observable<AnalystProgressResponse>;

  abstract submitAsk(request: AskChatRequest): Observable<ReportJobStatus>;

  abstract getTurnStatus(jobId: string): Observable<AnalystTurnStatus>;

  abstract cancelTurn(jobId: string): Observable<void>;

  abstract generateReport(request: GenerateReportRequest): Observable<ReportJobStatus>;

  abstract getReportJob(jobId: string): Observable<ReportJobStatus>;

  abstract cancelReportJob(jobId: string): Observable<void>;

  abstract getChats(): Observable<ChatResponse[]>;

  abstract getChatWithMessages(id: string): Observable<ChatWithMessagesResponse>;

  abstract patchChat(id: string, request: PatchChatRequest): Observable<void>;

  abstract deleteChat(id: string): Observable<void>;

  abstract creditBalance$: Observable<CreditBalanceResponse | null>;

  abstract getCreditBalance(): Observable<CreditBalanceResponse>;

  abstract refreshCreditBalance(): void;

  abstract getRecentConsumption(): Observable<CreditConsumptionEntry[]>;

  abstract submitFeedback(request: SubmitFeedbackRequest): Observable<void>;

  abstract clearFeedback(messageId: string): Observable<void>;

  abstract exportMessage(messageId: string, format: ChatMessageExportFormat): Observable<HttpResponse<Blob>>;
}
